<template>
    <div>
        <az-break-title title="Desconto Progressivo" />

        <div>
            <div class="row mb-3">
                <div class="col col-12 col-md-6">
                    <az-input icon="fas fa-search" v-model="search">
                        <template v-slot:buttonposb v-if="false">
                            <div class="input-group-append">
                                <button class="btn btn-outline-secondary" type="button" @click="copiar()">
                                    <i class="fas fa-copy"></i>
                                </button>
                            </div>
                        </template>
                    </az-input>
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <div class="btn-group mb-1" role="group" aria-label="Basic example">
                        <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'A'">
                            Ativos
                        </button>
                        <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'T'">
                            Todos
                        </button>
                    </div>
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <button
                        type="button"
                        class="btn btn-outline-success"
                        @click="incluir ()">
                        Incluir
                    </button>
                </div>
            </div>
        </div>

        <az-empty-state v-if="!lista || !lista.length" icon="fa-solid fa-percent" />

        <div class="list-group mb-3 az-anime-surgir mb-3">
            <li class="list-group-item d-flex justify-content-between" v-for="(dado, id) in lista" :key="id">
                <span>
                    <a href="#" @click.prevent="editar(dado)" class="h5 card-link mb-0 mr-3">
                        {{ dado.search }}
                    </a>
                </span>
                <span class="d-flex">
                    <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                        <input
                        type="checkbox"
                        class="custom-control-input"
                        :id="'ativo-' + id"
                        v-model="dado.fl_ativo"
                        @change="toggle(dado)"
                        />
                        <label class="custom-control-label" :for="'ativo-' + id"></label>
                    </div>
                    <div v-else>
                        {{ $util.formatMoeda(dado.dc_desconto) }}%
                    </div>
                </span>
            </li>
        </div>

        <!-- Modal -->
        <div class="modal fade" id="editarModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title">Desconto {{ item.id_desconto_progressivo ? '#' + item.id_desconto_progressivo : 'Novo' }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col col-12">
                                <az-input 
                                    label="Título"
                                    placeholder="Não definido..."
                                    v-model="item.st_titulo" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12 col-md-4">
                                <az-input
                                    label="De (Qtd Itens)"
                                    type="number"
                                    :validate="validate"
                                    v-model="item.in_qt_min" />
                            </div>
                            <div class="col col-12 col-md-4">
                                <az-input
                                    label="Até (Qtd Itens)"
                                    type="number"
                                    required
                                    :validate="validate"
                                    v-model="item.in_qt_max" />
                            </div>
                            <div class="col col-12 col-md-4">
                                <az-input
                                    icon="fa fa-percent"
                                    label="Desconto"
                                    type="money"
                                    :validate="validate"
                                    v-model="item.dc_desconto" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12 col-md-4">
                                <az-input
                                    label="Vigência Início"
                                    type="date"
                                    :validate="validate"
                                    v-model="item.dt_vigencia_inicio" />
                            </div>
                            <div class="col col-12 col-md-4">
                                <az-input
                                    label="Vigência Término"
                                    type="date"
                                    :validate="validate"
                                    v-model="item.dt_vigencia_termino" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    label="Observação"
                                    v-model="item.st_obs" />
                            </div>
                        </div>

                        <!-- Filtros -->
                        <filtro-model v-model="item.filtros" :validate="validate" :opcoes="lista_opcoes_filtro" class="mt-3" />
                        <br><br>
                    </div>
                    <div class="modal-footer">
                        <az-audit-log-button v-if="item && item.id_desconto_progressivo" model="descontoProgressivo" :id="item.id_desconto_progressivo" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar()">{{ item.id_desconto_progressivo ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzBreakTitle from "../../../util/AzBreakTitle.vue";
import AzEmptyState from "../../../util/AzEmptyState.vue";
import AzInput from "../../../shared/forms/AzInput.vue";
import AzSubmit from "../../../util/AzSubmit.vue";
import AzAuditLogButton from '../../../util/AzAuditLogButton.vue';
import FiltroModel from '../../shared/FiltroModel.vue';

export default {
    data() { 
        return { 
            dados: null, 
            search: "", 
            item: null, 
            validate: false, 
            viewMode: "A",
        }
    },

    computed: {
        lista_opcoes_filtro: function () {
            let opcoes = [
                {id:'App\\azure\\classeProcedimento', search:'Classe do Procedimento', service: 'classe_procedimentos.index', model_id: 'id_classe_procedimento'},
                {id:'App\\azure\\especialidade', search:'Especialidade', service: 'especialidades.index', model_id: 'id_especialidade'},
                {id:'App\\azure\\procedimentoGrupo', search:'Grupo de Procedimento', service: 'procedimento_grupos.index'}, 
                {id:'App\\azure\\plano', search:'Operadora/Plano', service: 'planos.index', nosync: true, model_id: 'id_plano'},
                {id:'App\\azure\\procedimento', search:'Procedimento', service: 'procedimentos.index', model_id: 'id_procedimento'},
                {id:'App\\azure\\medico', search:'Prestador', service: 'medicos.index', model_id: 'id_pessoa'},
                {id:'App\\azure\\recepcao', search:'Recepção', service: 'recepcaos.index', parms: { filtros: true }, model_id: 'id_recepcao'},
                {id:'App\\azure\\unidadeOperacao', search:'Unidade',service:'unidade_operacaos.index', model_id: 'id_unidade_operacao'}
            ];

            return _.orderBy(opcoes, 'search');
        },

        lista: {
            get() {
                let pesquisar = this.search.trim();
                let parts = pesquisar.replace(" ", ".*");
                let match = parts;
                let reg = new RegExp(match, "i");

                return this.dados && this.dados.length
                ? this.dados.filter(item => this.viewMode == 'T' || item.fl_ativo)
                    .filter(item => {
                        return !this.search || reg.test(JSON.stringify(item));
                    })
                : null;
            },
            set(newLista) {
                this.dados = newLista;
            }
        }
    },

    props: ['id_operadora', 'operadoras'],

    components: { 
        AzBreakTitle, 
        AzEmptyState,
        AzInput,
        AzSubmit,
        AzAuditLogButton,
        FiltroModel
    },

    methods: { 
        copiar() { 
            this.$refs.copiador.copiar();
        },

        incluir() { 
            this.validate = false;
            this.item = null; 

            this.$nextTick(() => { 
                this.item = {
                    id_desconto_progressivo: null,
                    id_operadora: this.id_operadora,
                    fl_ativo: true,
                    st_titulo: "",
                    st_obs: "",
                    in_qt_min: null, 
                    in_qt_max: null,
                    dc_desconto: 0, 
                };

                $("#editarModal").modal("show");
            });
        },

        editar(item) { 
            this.validate = false;
            this.item = null;

            this.$nextTick(() => { 
                this.item = _.cloneDeep(item);
                $('#editarModal').modal('show');
            });
        },

        load() { 
            this.$util.load(this, { 
                service: 'descontos_progressivos',
                parms: { 
                    where: { id_operadora: this.id_operadora },
                }
            });
        },

        toggle(item) {
            this.$util.toggle(this, { 
                service: 'descontos_progressivos',
                dados: item, 
            });
        },

        atualizar() { 
            this.$util.atualizar(this, { 
                service: 'descontos_progressivos',
                dados: this.item, 
                modal: 'editarModal',
                reload: true, 
            });
        }
    },

    mounted() { 
        this.load(); 
    }

}
</script>